<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import AlertBox from '@/components/Elements/Alerts/AlertBox.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext } from '../tutorialSteps'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_government_intro')
}

const isOnGovernmentSection = computed(() => {
  return route.path.startsWith('/government')
})

const goToGovernment = () => {
  router.push('/government/cabinet')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/government.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.government.intro.welcome') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.government.intro.helpCabinet') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.government.intro.meetCandidates') }}
      </p>
    </template>

    <template #alerts>
      <AlertBox type="info" class="hidden md:flex">
        {{ t('tutorial.government.intro.clickGovernmentDesktop') }}
      </AlertBox>
      <AlertBox type="info" class="md:hidden">
        {{ t('tutorial.government.intro.clickGovernmentMobile') }}
      </AlertBox>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnGovernmentSection" @click="goToGovernment" class="mr-2">
        {{ t('tutorial.government.intro.goToGovernment') }}
      </ActionButton>
      <ActionButton @click="handleNextStep">
        {{ t('tutorial.government.intro.gotIt') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>